module.exports = __webpack_public_path__ + "static/media/alignjustified.9aa37eee.svg";